module.exports = __webpack_public_path__ + "static/img/wechat.b7bff3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/img/footer_icon/wechat.png
// module id = GJR9
// module chunks = 0